// Constants
import Vue from 'vue';
import FormDataService from 'services/form-data.service';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import UnitTypeConstants from '../../constants/column-name/unit-type.column-name.constants';
import UnitTypeFormConstants from '../../constants/form/unit-type.form.constants';

export default Vue.component('window', {
  template: `
    <AddEditForm title='${UnitTypeFormConstants.FormTitle}' ref="addEditForm" @submit-button-clicked="onFormSubmit">
      ${FormDataService.textInput(UnitTypeConstants.unitTypeName)}
      ${FormDataService.textInput(UnitTypeConstants.suggestedInterval)}
    </AddEditForm>`,
  name: UnitTypeFormConstants.FormName,
  data() {
    return {
      formData: {}
    };
  },
  mixins: [AddEditMixin],
  methods: {
    checkForm() {
      return this.checkFormSubmission(UnitTypeConstants);
    },
    openDialog(data) {
      this.formData = { ...data };

      if (!this.formData[UnitTypeConstants.suggestedInterval.field]) {
        this.formData[UnitTypeConstants.suggestedInterval.field] = UnitTypeConstants.suggestedInterval.defaultValue;
      }

      this.$refs.addEditForm.openDialog(data);
    }
  },
  components: {
    AddEditForm
  }
});
